<div class="row justify-content-center" [ngClass]="routeAnimationsElements">
  <h2 class="mat-h2" mat-dialog-title> Solicitud de acreditación para Técnico Responsable</h2>
  <rpe-tecnico-responsable-acreditacion-form [formInput]="formInput" (formValueChanges)="formValueChanges($event)"
    (formStatusChanges)="formStatusChanges($event)">
  </rpe-tecnico-responsable-acreditacion-form>
  <div class="row buttons d-flex justify-content-between pad" [ngClass]="routeAnimationsElements">
    <button type="reset" (click)="onCancel()" mat-raised-button>
      {{ 'rpe.vista-usuario.cancelar' | translate }}
    </button>
    <button type="submit" mat-raised-button (click)="onSubmit()" color="primary">
      Confirmar
    </button>
  </div>
</div>
